module.exports = __webpack_public_path__ + "static/media/buyer2.1baecd49.jpg";